import calculateUtil from '../../../static/js/calculateUtil'
import objectUtil from '../../../static/js/objectUtil'

const setValue = objectUtil.setValueByPath
const getValue = objectUtil.getValueByPath
// {
//   code: != 200,
//   msg: ...,
//   errors: [],
//   data: ...
// }
class Response {
  constructor(init = {}) {
    ;(this.code = init.code || 200),
      (this.msg = init.code || '成功'),
      (this.errors = init.errors || null),
      (this.data = init.data || null)
  }
}

const ERROR_SCAN_MESSAGE_SERIAL_AMOUNT = '该商品已开启序列号管理，数量不可大于 1'
const ERROR_SCAN_MESSAGE_SERIAL = '序列号已存在'

export default {
  props: {
    store: Object,
    importGoodsAndBatchByTrackUrl: String,
    importGoodsAndBatchByTrackParam: {
      type: Object,
      default: () => ({}),
    },
    importInventoryUrl: String,
    importInventoryParam: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    //找出所有商品相同的行，如果存在ifParent表示明细中存在parent，主行和从行的parent一样
    seachRows(ifParent) {
      let arr = new Map()
      this.tableData.map((item, index) => {
        let one =
          this.scanFormData[this.dataGoodsInfoKey].id &&
          item[this.dataGoodsInfoKey].id === this.scanFormData[this.dataGoodsInfoKey].id
        let two =
          !this.scanFormData[this.dataGoodsInfoKey].id &&
          this.scanFormData[this.dataGoodsKeepingKey].epc &&
          item[this.dataGoodsKeepingKey].epc === this.scanFormData[this.dataGoodsKeepingKey].epc
        if (one || two) {
          if (ifParent) {
            if (!item.parent) {
              console.error('没有parent')
            }
            let now = arr.get(item.parent)
            if (now) {
              now.push({ index, item })
            } else {
              arr.set(item.parent, [{ index, item }])
            }
          } else {
            arr.set(index, item)
          }
        }
      })
      return arr
    },
    //找出主行
    seachMaster(arr, key) {
      return arr.find((item) => getValue(item, key ? `${key}.master` : 'master'))
    },
    amountTotal(arr, key) {
      const temp = arr.reduce((acc, cur) => calculateUtil.numberAdd(acc, getValue(cur, key)), 0)
      return temp
    },
    //校验所扫项在行中是否为空，
    checkRowValIsNull(row, scanData) {
      for (let [key] of scanData) {
        if (getValue(row, `${this.dataGoodsKeepingKey}.${key}`)) {
          return false
        }
      }
      return true
    },
    //校验所扫项在行中是否相等，
    //     三、相关单据的扫码记录合并规则如下：（即主键字段是哪些）
    // 1、采购验收单：商品sku、批号、序列号、自定义序列号、生产日期、验收结论。
    // 2、采购入库单：商品sku、批号、序列号、自定义序列号、生产日期、货位。
    // 3、补货出库单：商品sku、批号、序列号、自定义序列号、生产日期、货位、入库批次（这个咋办，待核实）。
    // 4、补货入库单：商品sku、批号、序列号、自定义序列号、生产日期、货位、入库批次（这个咋办，待核实）。
    // 5、盘点单：商品sku、批号、序列号、自定义序列号、生产日期、货位、入库批次（这个咋办，待核实）。
    checkRowValIsEq(row, scanData, keys = ['batchNumber', 'serialNumber', 'periodBegin']) {
      // #35947，将厂家原始条码排除到匹配明细之外
      keys.push('originBarCode', 'originBarCodeDisplay')
      for (let key of keys) {
        let val =
          key in this.scanFormData[this.dataGoodsKeepingKey]
            ? getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.${key}`)
            : scanData.get(key)
        if (getValue(row, `${this.dataGoodsKeepingKey}.${key}`) !== val) {
          return false
        }
      }

      return true
    },
    /** @name 校验所选项中批号信息是否与任务中匹配 */
    checkRowAndSelectBatchIsEq(
      row,
      goodsKeeping,
      // 去掉有效期至、失效日期、厂家原始条码的匹配
      excludes = ['periodEnd', 'periodExpire']
    ) {
      // #35947，将厂家原始条码排除到匹配明细之外
      excludes.push('originBarCode', 'originBarCodeDisplay')
      for (let key in goodsKeeping) {
        if (
          !excludes.includes(key) &&
          typeof goodsKeeping[key] !== 'object' &&
          getValue(row, `${this.dataGoodsKeepingKey}.${key}`) &&
          getValue(row, `${this.dataGoodsKeepingKey}.${key}`) !== goodsKeeping[key]
        ) {
          return false
        }
      }
      return true
    },
    // #6553,校验是否开启序列号或自定义序列号管理
    ifSerial(scanFormData) {
      return scanFormData.keepingSerial
    },
    /**
     * 校验扫码数量是否已超出待处理数量 eg. amount > plan
     *
     * @description status=true 通过，否则不通过
     * @param {*} [row] 当前行数据
     * @param {Boolean} [ifEdit=false] 当前行数据
     * @returns {*} result 校验结果 eg. { status: false, message: '累计扫码数量已经超出了待处理数量，请仔细检查！' }
     */
    checkTotalAmount(row, ifEdit = false) {
      // 未配置 treeRes 说明未拆行，则无需此判断
      if (!this.treeRes) return { status: true }

      let task = this.seachRows(true)
      const result = {}
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        // 如果是编辑，则减掉编辑的行数据 row.amount
        if (ifEdit && row?.amount) {
          nowAmount = calculateUtil.numberSub(nowAmount, row.amount)
        }
        let masterRow = this.seachMaster(val, 'item')
        // 所有主从行的数量之和（包括此次扫码的数量） 大于计划数量
        result.status = nowAmount <= masterRow.item[this.dataPendingKey]
        if (!result.status) break
      }
      if (!result.status) {
        result.message = '累计扫码数量已经超出了待处理数量，请仔细检查！'
      } else {
        result.message = null // message 不为 null 会显示提示信息。详见：ifEdit 调用的地方
      }

      return result
    },
    /**
     * @name 查找所属的主行数据，并添加至数组开头
     * @param {*} row 待处理的数据
     *
     */
    searchMasterToFirst(row) {
      // 未开启单条模式，则忽略此函数的处理逻辑；开启单条模式，则根据 row.parent、row._ID 是否有值确定是否忽略此函数的处理逻辑
      if (!this.isSingle || !row?.parent || !row?._ID) return
      // 过滤掉 taskData 中的 row
      const list = this.taskData.filter((t) => t._ID !== row._ID)
      // 查找相同 parent 的数据（不包含: row）
      let arr = this.tableData.filter((t) => t.parent === row.parent && t._ID !== row._ID)
      // 数据交换，如果 arr 中的数据在 taskData 中存在，则交换为 taskData 的数据，否则交换为 arr 的数据
      arr = arr.reduce((prev, cur) => {
        const fIndex = list.findIndex((t) => t._ID === cur._ID)

        prev.push(fIndex > -1 ? list[fIndex] : cur)
        if (fIndex > -1) list.splice(fIndex, 1) // 删除 taskData 中在原 arr 中存在的数据

        return prev
      }, [])

      this.taskData = [row, ...arr, ...list]
      // row 不是主行
      if (!row?.master) {
        // 查找 taskData 的主行
        const mIndex = this.taskData.findIndex((t) => t.master)
        this.taskData = this.rowToFrist(this.taskData, mIndex)
      }
    },
    /**
     * 同步更新 taskData
     *
     * @param {*} row 待同步的数据
     * @param {boolean} [insert=false] 是否是新增模式
     * @returns
     */
    syncUpdateTaskData(row = null, insert = false) {
      // 新增
      if (insert) {
        this.taskData = [row, ...this.taskData]
        // 查找主行并添加至开头
        this.searchMasterToFirst(row)
        return
      }
      // 更新
      if (row?._ID) {
        const nIndex = this.taskData.findIndex((task) => task._ID === row?._ID)
        if (nIndex > -1) {
          this.taskData = this.rowToFrist(this.taskData, nIndex)
          this.taskData[0] = row
        } else {
          this.taskData = [row, ...this.taskData]
        }

        // 查找主行并添加至开头
        this.searchMasterToFirst(row)

        return
      }

      // 执行到这里说明出错啦
      throw new Error('同步更新 taskData 的数据异常')
    },
    /**
     * 判断是否是编辑
     *
     * @description 如果_ID相同则是编辑，且需要根据参数的值确定是否校验数量
     * @param {*} scanFormData 扫码区表单数据
     * @param {*} [disabledCheckAmount=false] 是否禁止校验已扫数量 > 待处理数量 Tip: 无源的情况无需校验
     * @returns {Boolean}
     */
    ifEdit(scanFormData, disabledCheckAmount = false) {
      let m = new Map()
      let index = -1
      // 查找所有主行 和 _ID 相同的索引
      this.tableData.forEach((item, nIndex) => {
        if (item._ID && item._ID === scanFormData._ID) index = nIndex
        if (item.master && item?.parent) m.set(item.parent, item)
      })
      if (index !== -1) {
        // 有源：判断已扫数量是否小于待处理数量，如果大于则给出提示
        const { parent } = this.tableData[index]
        const { plan } = m.get(parent) ?? {}

        // const plan = this.tableData[index][this.dataPendingKey]
        if (parent && scanFormData[this.dataAmountKey] > plan) {
          return { message: '累计扫码数量已经超出了待处理数量，请仔细检查！' }
        }

        // 校验已扫数量 > 待处理数量
        if (!disabledCheckAmount) {
          const { status, message } = this.checkTotalAmount(this.tableData[index], true)
          // 校验不通过，返回 { message }，则会提示错误信息
          if (!status) return { message }
        }

        // 灵科 - 待处理-来自收货通知单，amount 的值不相等时，调反算
        if (scanFormData[this.dataAmountKey] !== this.tableData[index][this.dataAmountKey]) {
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', scanFormData, {})
        }
        this.tableData[index] = scanFormData
        this.tableData = this.rowToFrist(this.tableData, index)
        // 同步更新 taskData
        this.syncUpdateTaskData(this.tableData[0])

        this.setTreeExpand()

        return true
      }
      return false
    },
    //在选择的情况下，如果扫码信息中没有的值，根据选中的数据填入
    setScanData(scanData, scanFormData) {
      let temp = new Map(scanData)
      if (!temp.get('batchNumber') && scanFormData?.[this.dataGoodsKeepingKey]?.batchNumber)
        temp.set('batchNumber', scanFormData[this.dataGoodsKeepingKey].batchNumber)
      if (!temp.get('periodBegin') && scanFormData?.[this.dataGoodsKeepingKey]?.periodBegin)
        temp.set('periodBegin', scanFormData[this.dataGoodsKeepingKey].periodBegin)
      if (!temp.get('storageNumber') && scanFormData?.[this.dataGoodsKeepingKey]?.storageNumber)
        temp.set('storageNumber', scanFormData[this.dataGoodsKeepingKey].storageNumber)
      return temp
    },
    //将所扫项赋值到行
    // setValToRow(row, scanData) {
    //   for(let [key, val] of scanData) {
    //     setValue(row, `${this.dataGoodsKeepingKey}.${key}`, val)
    //   }
    // },
    //拆行逻辑
    getSplitRow(row) {
      let splitRow = JSON.parse(JSON.stringify(row))
      //主行master强制置为false,计划数量置为null
      splitRow.plan = null
      splitRow.master = false
      splitRow.id = null
      // splitRow.goodsStore.batchNumber= null;
      // splitRow.goodsStore.serialNumber= null;
      // splitRow.goodsStore.periodBegin= null;
      // splitRow.goodsStore.periodExpire= null;
      // splitRow.goodsStore.periodEnd= null;

      // splitRow.amountDisplay=scanAmountDisplay;
      // splitRow.amount=amount;

      splitRow._ID = objectUtil.createID()
      return splitRow
    },
    //灵科的商品结构转化
    linkGoods() {
      if (this.dataGoodsInfoKey === 'goodsInfo') {
        const item = this.scanFormData[this.dataGoodsInfoKey]
        const arr = ['manufacturer', 'nature', 'dosage', 'minClaimUnit']
        for (let key of arr) {
          if (key === 'minClaimUnit') {
            this.scanFormData.minClaimUnit = item[key] || null
          } else {
            item[`${key}Name`] = item[key]?.name || null
          }
        }
      }
    },
    //从库存选择时校验库存id是否相同
    checkBatchIsEq(row, scanFormData) {
      let key =
        this.dataGoodsKeepingKey === 'goodsStore' ? 'goodsStore.storageItemId' : 'storageItem.id'
      return getValue(row, key) === getValue(scanFormData, key)
    },
    //从库存选择时校验商品id是否相同
    checkGoodsIsEq(row, scanFormData) {
      let key = `${this.dataGoodsInfoKey}.id`
      return getValue(row, key) === getValue(scanFormData, key)
    },
    //将数组的index位置元素挪位到第一个
    rowToFrist(arr, index) {
      while (index > 0) {
        let temp = arr[index]
        arr[index] = arr[index - 1]
        arr[index - 1] = temp
        index--
      }
      return [...arr]
    },
    //获取验收结论的key
    getAcceptStatusKey() {
      return this.dataGoodsKeepingKey === 'goodsStore'
        ? 'acceptStatus'
        : 'attrs.valueEnum.acceptResult'
    },
    //判断keys中的字段是否相等是否相同
    checkGoodAndBatchIsEq(row, scanFormData, keys = []) {
      return !keys.some(
        (key) => getValue(scanFormData, key) && getValue(scanFormData, key) !== getValue(row, key)
      )
    },
    //校验验收结论，是否相同
    checkAcceptStatus(row, scanFormData) {
      return (
        !getValue(scanFormData, `${this.getAcceptStatusKey()}.code`) ||
        getValue(scanFormData, `${this.getAcceptStatusKey()}.code`) ===
          getValue(row, `${this.getAcceptStatusKey()}.code`)
      )
    },
    //校验货位，是否相同
    checkLocationOfId(row, scanFormData) {
      return (
        !getValue(scanFormData, `location.id`) ||
        getValue(scanFormData, `location.id`) === getValue(row, `location.id`)
      )
    },
    //校验模式---校验扫码信息与任务明细是否匹配，是就累加数量，否就提示
    modelCheckout() {
      let msg = '未匹配到商品'
      // 修复#31795、#31557（其他模式如果编辑后不能累加数量，则也添加此代码），如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(true)
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，找到和扫码信息相同的项进行数量累加
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            if (
              this.checkRowAndSelectBatchIsEq(
                item.item,
                this.scanFormData[this.dataGoodsKeepingKey]
              )
            ) {
              // 修复#31796时，发现的验收结论未更新至上表的问题
              if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
                setValue(
                  item.item,
                  this.getAcceptStatusKey(),
                  getValue(this.scanFormData, this.getAcceptStatusKey())
                )
              }
              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                this.scanFormData[this.dataAmountKey],
                item.item[this.dataAmountKey]
              )
              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            } else {
              msg = '未匹配到任务或累计扫码数量已经超出了待处理数量，请仔细检查！'
            }
          }
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }

      return msg
    },
    //校验模式--有源--校验扫码信息和货位与任务明细是否匹配，是就累加数量
    modelCheckoutAndLocation() {
      let msg = '未匹配到商品'
      // 修复#31557（其他模式如果编辑后不能累加数量，则也添加此代码），如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(true)
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，找到和扫码信息相同的项进行数量累加
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            //如果货位相同且批号相同直接累加数量，当行中没有批号时不需要匹配批号信息
            if (
              (!getValue(this.scanFormData, 'location.id') ||
                getValue(item.item, 'location.id') ===
                  getValue(this.scanFormData, 'location.id')) &&
              (!getValue(item.item, `${this.dataGoodsKeepingKey}.batchNumber`) ||
                this.checkRowAndSelectBatchIsEq(
                  item.item,
                  this.scanFormData[this.dataGoodsKeepingKey]
                ))
            ) {
              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                this.scanFormData[this.dataAmountKey],
                item.item[this.dataAmountKey]
              )
              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            } else {
              msg = '未匹配到任务或累计扫码数量已经超出了待处理数量，请仔细检查！'
            }
          }
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }

      return msg
    },
    //校验模式--有源--校验扫码信息与任务明细是否匹配，是就累加数量，否就提示(带录入货位，同批号不同货位，自动拆行)， 也支持录入验收结论，验收结论不同则进行拆行
    modelCheckoutInputLocation(split = false) {
      let msg = '未匹配到商品'
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(true)
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，找到和扫码信息相同的项进行数量累加
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            //如果货位相同且批号相同直接累加数量
            const ifOne =
              item.item[this.dataAmountKey] &&
              getValue(item.item, 'location.id') === getValue(this.scanFormData, 'location.id')
            const ifTwo =
              !item.item[this.dataAmountKey] || !getValue(this.scanFormData, 'location.id')
            if (
              (ifOne || ifTwo) &&
              (!item.item[this.dataAmountKey] ||
                this.checkAcceptStatus(item.item, this.scanFormData)) &&
              (!getValue(item.item, `${this.dataGoodsKeepingKey}.batchNumber`) ||
                this.checkRowAndSelectBatchIsEq(
                  item.item,
                  this.scanFormData[this.dataGoodsKeepingKey]
                ))
            ) {
              if (this.scanFormData.location && !item.item[this.dataAmountKey]) {
                //当没有数量时，直接将选择的货位填入明细
                setValue(item.item, 'location', this.scanFormData.location) //设置货位
              } else if (!getValue(item.item, 'location') && this.scanFormData.location) {
                setValue(item.item, 'location', this.scanFormData.location) //设置货位
              }

              if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
                setValue(
                  item.item,
                  this.getAcceptStatusKey(),
                  getValue(this.scanFormData, this.getAcceptStatusKey())
                )
              }

              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                this.scanFormData[this.dataAmountKey],
                item.item[this.dataAmountKey]
              )
              item.item.scanMethod = 'SCAN' // #9818
              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            }
          }
          //当找完一轮都没有匹配的，则匹配最近的商品和批号相同进行拆分
          if (
            split &&
            this.checkRowAndSelectBatchIsEq(
              masterRow.item,
              this.scanFormData[this.dataGoodsKeepingKey]
            )
          ) {
            let newRow = this.getSplitRow(masterRow.item)
            newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
            newRow.location = this.scanFormData.location
            newRow[this.dataGoodsKeepingKey] = this.scanFormData[this.dataGoodsKeepingKey]
            newRow.scanMethod = 'SCAN' // #9818
            if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
              setValue(
                newRow,
                this.getAcceptStatusKey(),
                getValue(this.scanFormData, this.getAcceptStatusKey())
              )
            }
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            this.tableData = [newRow, ...this.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true)

            this.setTreeExpand()
            return
          }
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }

      if (!split) {
        return this.modelCheckoutInputLocation(true)
      }

      return msg
    },
    //校验模式--无源--校验扫码信息与任务明细是否匹配，是就累加数量，否就提示(带录入货位，同批号不同货位，自动拆行)
    modelPassiveCheckoutInputLocation() {
      let msg = '未匹配到商品'
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData, true)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(false)
      for (let [index, val] of task) {
        let nowAmount = calculateUtil.numberAdd(
          val[this.dataAmountKey],
          this.scanFormData[this.dataAmountKey]
        )
        if (nowAmount <= val[this.dataPendingKey]) {
          const ifOne =
            val[this.dataAmountKey] &&
            getValue(val, 'location.id') === getValue(this.scanFormData, 'location.id')
          const ifTwo = !val[this.dataAmountKey]
          if (
            (ifOne || ifTwo) &&
            this.checkRowAndSelectBatchIsEq(val, this.scanFormData[this.dataGoodsKeepingKey])
          ) {
            val[this.dataAmountKey] = nowAmount
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', val, {})
            this.tableData = this.rowToFrist(this.tableData, index)
            // 同步更新 taskData
            this.syncUpdateTaskData(this.tableData[0])

            this.setTreeExpand()
            return
          } else {
            msg = '未匹配到任务或累计扫码数量已经超出了待处理数量，请仔细检查！'
          }
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }

      return msg
    },
    //盘点,根据扫码信息在明细中查询，点击确认时将查询出来的明细添加到上表，数量相同就累加，最后点击保存时提交到后台
    modelCheckOrder() {
      const { data: scanData } = this.scanResult
      const ifEdit = this.scanStatus === 'update'
      const stockingAmount = this.scanFormData.stockingAmount
      const ifCheckSerial =
        this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
          this.diAreaColumns,
          this.serialAreaColumns,
          this.piAreaColumns,
          this.otherAreaColumns,
        ]) && this.ifSerial(this.scanFormData[this.dataGoodsInfoKey])
      const clearCodeAndAnalysisMessages = () => {
        this.code = ''
        this.analysisMessages = []
      }

      // 开启序列号管理后，校验扫码扫到的数量是否大于 1
      if (ifCheckSerial && stockingAmount > 1) {
        clearCodeAndAnalysisMessages()
        return ERROR_SCAN_MESSAGE_SERIAL_AMOUNT
      }

      let checkArr = this.setCheckArr()
      for (const item of this.tableData) {
        const isSame =
          this.checkGoodAndBatchIsEq(item, this.scanFormData, checkArr) &&
          this.checkRowValIsEq(item, scanData, ['batchNumber', 'serialNumber'])

        if (!ifCheckSerial || !isSame) continue

        const nowAmount = ifEdit
          ? stockingAmount
          : calculateUtil.numberAdd(item.stockingAmount, stockingAmount)

        if (nowAmount > 1) {
          clearCodeAndAnalysisMessages()
          return ERROR_SCAN_MESSAGE_SERIAL_AMOUNT
        }
        if (!ifEdit) {
          clearCodeAndAnalysisMessages()
          return ERROR_SCAN_MESSAGE_SERIAL
        }
      }

      const taskIndex = this.tableData.findIndex((im) => im.id === this.scanFormData.id)
      if (taskIndex === -1) {
        this.tableData = [this.scanFormData, ...this.tableData]
      } else {
        let taskItem = this.tableData[taskIndex]
        // 如果是编辑则更新数量
        taskItem.stockingAmount =
          ifEdit || ifCheckSerial
            ? stockingAmount
            : calculateUtil.numberAdd(taskItem.stockingAmount, stockingAmount)

        this.tableData = this.rowToFrist(this.tableData, taskIndex)
        // 同步更新 taskData
        this.syncUpdateTaskData(this.tableData[0])

        this.setTreeExpand()
      }
    },

    //录入模式--有源--通过所扫商品与任务明细进行匹配，将扫码其他信息录入到任务明细，累加数量时需要判断验收结论
    modelimport() {
      const { data: scanData } = this.scanResult
      let msg = '未匹配到商品'
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(true)
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            if (this.checkRowValIsNull(item.item, scanData)) {
              //如果扫码的库存信息在对应商品任务明细中为空则赋值到任务明细
              if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
                setValue(
                  item.item,
                  this.getAcceptStatusKey(),
                  getValue(this.scanFormData, this.getAcceptStatusKey())
                )
              }
              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              if (getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCode`)) {
                setValue(
                  item.item,
                  `${this.dataGoodsKeepingKey}.originBarCode`,
                  getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCode`)
                )
              }
              if (getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)) {
                setValue(
                  item.item,
                  `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
                  getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)
                )
              }

              item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                item.item[this.dataAmountKey],
                this.scanFormData[this.dataAmountKey]
              )

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            } else {
              if (
                this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                  this.serialAreaColumns,
                  this.piAreaColumns,
                  this.otherAreaColumns,
                ]) &&
                this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkRowValIsEq(item.item, scanData, ['batchNumber', 'serialNumber'])
              ) {
                return ERROR_SCAN_MESSAGE_SERIAL
              }

              if (
                !this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkRowValIsEq(item.item, scanData) &&
                this.checkAcceptStatus(item.item, this.scanFormData)
              ) {
                //如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                  item.item[this.dataAmountKey],
                  this.scanFormData[this.dataAmountKey]
                )
                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                this.tableData = this.rowToFrist(this.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(this.tableData[0])

                this.setTreeExpand()
                return
              }
            }
          }
          //执行到这里说明应该进行拆行
          let newRow = this.getSplitRow(masterRow.item)
          if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
            setValue(
              newRow,
              this.getAcceptStatusKey(),
              getValue(this.scanFormData, this.getAcceptStatusKey())
            )
          }
          // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
          if (getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCode`)) {
            setValue(
              newRow,
              `${this.dataGoodsKeepingKey}.originBarCode`,
              getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCode`)
            )
          }
          if (getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)) {
            setValue(
              newRow,
              `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
              getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)
            )
          }

          newRow[this.dataGoodsKeepingKey] = objectUtil.clone(
            this.scanFormData[this.dataGoodsKeepingKey]
          )
          newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
          this.tableData = [newRow, ...this.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(newRow, true)

          this.setTreeExpand()
          return
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }
      return msg
    },
    //录入模式--有源--通过所扫商品与任务明细进行匹配，将扫码其他信息录入到任务明细，累加数量时需要判断验收结论和货位
    modelimportAndInputLocation() {
      const { data: scanData } = this.scanResult
      let msg = '未匹配到商品'
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      let task = this.seachRows(true)
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            if (this.checkRowValIsNull(item.item, scanData)) {
              //如果扫码的库存信息在对应商品任务明细中为空则赋值到任务明细
              if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
                setValue(
                  item.item,
                  this.getAcceptStatusKey(),
                  getValue(this.scanFormData, this.getAcceptStatusKey())
                )
              }
              // 将货位信息更新到任务明细中
              if (getValue(this.scanFormData, 'location')) {
                setValue(item.item, 'location', getValue(this.scanFormData, 'location'))
              }
              item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                item.item[this.dataAmountKey],
                this.scanFormData[this.dataAmountKey]
              )

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            } else {
              if (
                this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                  this.serialAreaColumns,
                  this.piAreaColumns,
                  this.otherAreaColumns,
                ]) &&
                this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkRowValIsEq(item.item, scanData, ['batchNumber', 'serialNumber'])
              ) {
                return ERROR_SCAN_MESSAGE_SERIAL
              }

              if (
                !this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkRowValIsEq(item.item, scanData) &&
                this.checkAcceptStatus(item.item, this.scanFormData) &&
                this.checkLocationOfId(item.item, this.scanFormData)
              ) {
                //如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                  item.item[this.dataAmountKey],
                  this.scanFormData[this.dataAmountKey]
                )
                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                this.tableData = this.rowToFrist(this.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(this.tableData[0])
                this.setTreeExpand()
                return
              }
            }
          }

          //执行到这里说明应该进行拆行
          let newRow = this.getSplitRow(masterRow.item)
          if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
            setValue(
              newRow,
              this.getAcceptStatusKey(),
              getValue(this.scanFormData, this.getAcceptStatusKey())
            )
          }
          if (getValue(this.scanFormData, 'location')) {
            setValue(newRow, 'location', getValue(this.scanFormData, 'location'))
          }

          newRow[this.dataGoodsKeepingKey] = objectUtil.clone(
            this.scanFormData[this.dataGoodsKeepingKey]
          )
          newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
          this.tableData = [newRow, ...this.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(newRow, true)

          this.setTreeExpand()
          return
        } else {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        }
      }
      return msg
    },
    //录入模式--有源--通过所扫商品与任务明细进行匹配，将扫码信息查询的库存录入到任务明细
    modelimportAndLocation() {
      let msg = '未匹配到商品'
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit) return ifEdit?.message

      // 判断库存是否充足
      if (this.scanFormData[this.dataAmountKey] > this.scanFormData.available) {
        return '库存不足'
      }
      this.linkGoods() //转换灵科的结构
      let task = this.seachRows(true)

      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        //所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (nowAmount > masterRow.item[this.dataPendingKey]) {
          msg = '累计扫码数量已经超出了待处理数量，请仔细检查！'
        } else {
          for (let item of val) {
            // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
            msg = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
            if (msg) return msg

            if (
              !getValue(
                item.item,
                this.dataGoodsKeepingKey === 'goodsStore'
                  ? 'goodsStore.storageItemId'
                  : 'storageItem.id'
              )
            ) {
              //如果扫码的库存信息在对应商品任务明细中为空则赋值到任务明细
              item.item = Object.assign(item.item, this.scanFormData)
              // #8365 处理添加到明细的数据
              const allData = this.tableData
              const prev = allData[0]
              if (prev?.instrument) item.instrument = prev.instrument

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            } else if (this.checkBatchIsEq(item.item, this.scanFormData)) {
              //如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
              item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                item.item[this.dataAmountKey],
                this.scanFormData[this.dataAmountKey]
              )
              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.tableData = this.rowToFrist(this.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(this.tableData[0])

              this.setTreeExpand()
              return
            }
          }
          if (this.scanFormData[this.dataAmountKey] <= this.scanFormData.available) {
            //执行到这里说明应该进行拆行
            let newRow = this.getSplitRow(masterRow.item)
            newRow = Object.assign(newRow, this.scanFormData)
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            // #8365 处理添加到明细的数据
            const allData = this.tableData
            const prev = allData[0]
            if (prev?.instrument) newRow.instrument = prev.instrument

            this.tableData = [newRow, ...this.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true)

            this.setTreeExpand()
            return
          } else {
            msg = '库存不足'
          }
        }
      }

      return msg
    },
    //录入模式--无源--跟台商品目录池，将所扫商品及批号信息添加进上表，最后保存直接调后台接口
    modelimportGoodsAndBatch() {
      this.tableData = [this.scanFormData, ...this.tableData]
      // 同步更新 taskData
      this.syncUpdateTaskData(this.scanFormData, true)

      this.setTreeExpand()
    },
    // 校验库存 id 相同时，商品 id 是否一致，如果不一致则报错
    checkStorageItemIdAndGoodsId(row, scanFormData) {
      // 库存 id 相同时
      if (this.checkBatchIsEq(row, scanFormData) && !this.checkGoodsIsEq(row, scanFormData)) {
        const scanGoodsDetail = scanFormData[this.dataGoodsInfoKey]
        const stoargeGoodsDetail = row[this.dataGoodsInfoKey]

        return `存在多条相同库存信息的商品${scanGoodsDetail.name}（${scanGoodsDetail.code}）和 ${stoargeGoodsDetail.name}（${stoargeGoodsDetail.code}）`
      }

      return false
    },
    //检查序列号是否唯一
    checkSerialNumberOnly(serialNumber) {
      return this.tableData.findIndex(
        (item) => getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`) === serialNumber
      )
    },
    //录入模式--无源--来自跟台目录，根据所扫商品与上表进行匹配，相同则数量累加，否则根据接口获取当前明细行，并加入上表
    async modelimportGoodsAndBatchByTrack() {
      // let checkArr = [
      //   `${this.dataGoodsKeepingKey}.batchNumber`,
      //   `${this.dataGoodsKeepingKey}.periodBegin`,
      // ]
      let checkArr = this.setCheckArr()
      if (getValue(this.scanFormData, `${this.dataGoodsInfoKey}.id`)) {
        checkArr.unshift(`${this.dataGoodsInfoKey}.id`)
      }
      let serialNumber = getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
      let serialNumberIndex = this.checkSerialNumberOnly(serialNumber)
      if (serialNumber && serialNumberIndex !== -1) {
        let serialNumberItem = this.tableData[serialNumberIndex]
        let nowAmount = calculateUtil.numberAdd(
          serialNumberItem[this.dataAmountKey],
          this.scanFormData[this.dataAmountKey]
        )
        if (
          nowAmount > 1 &&
          this.checkGoodAndBatchIsEq(serialNumberItem, this.scanFormData, checkArr)
        ) {
          return '该商品已开启序列号管理数量不能大于1'
        } else if (!this.checkGoodAndBatchIsEq(serialNumberItem, this.scanFormData, checkArr)) {
          return '保存失败，原因是序列号已经存在'
        } else {
          if (getValue(this.scanFormData, this.getAcceptStatusKey())) {
            setValue(
              serialNumberItem,
              this.getAcceptStatusKey(),
              getValue(this.scanFormData, this.getAcceptStatusKey())
            )
          }

          serialNumberItem[this.dataAmountKey] = nowAmount
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', serialNumberItem, {})
          this.tableData = this.rowToFrist(this.tableData, serialNumberIndex)
          // 同步更新 taskData
          this.syncUpdateTaskData(this.tableData[0])

          this.setTreeExpand()
          return
        }
      }
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i]
        let nowAmount = calculateUtil.numberAdd(
          item[this.dataAmountKey],
          this.scanFormData[this.dataAmountKey]
        )
        let tempArr = getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`)
          ? [...checkArr, `${this.dataGoodsKeepingKey}.serialNumber`]
          : checkArr
        if (
          this.checkGoodAndBatchIsEq(item, this.scanFormData, tempArr) &&
          (!this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) ||
            (this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) && nowAmount <= 1)) &&
          this.checkAcceptStatus(item, this.scanFormData)
        ) {
          if (
            getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`) &&
            !getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`)
          ) {
            setValue(
              item,
              `${this.dataGoodsKeepingKey}.serialNumber`,
              getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
            )
          }
          item[this.dataAmountKey] = nowAmount
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
          this.tableData = this.rowToFrist(this.tableData, i)
          // 同步更新 taskData
          this.syncUpdateTaskData(this.tableData[0])

          this.setTreeExpand()
          return
        }
      }
      //如果没有匹配的就新增一条
      let param = Object.assign({}, this.importGoodsAndBatchByTrackParam)
      param.parameters = Object.assign(
        {
          goodsId: this.scanFormData[this.dataGoodsInfoKey].id,
          batchNumer: this.scanFormData[this.dataGoodsKeepingKey].batchNumber,
        },
        this.importGoodsAndBatchByTrackParam?.parameters
      )
      const res = await this.$axios.post(this.importGoodsAndBatchByTrackUrl, param)
      if (res.data.code == 200 && res.data.data && res.data.data.length > 0) {
        let item = res.data.data[0]
        for (let key in this.scanFormData[this.dataGoodsKeepingKey]) {
          if (this.scanFormData[this.dataGoodsKeepingKey][key]) {
            item[this.dataGoodsKeepingKey][key] = this.scanFormData[this.dataGoodsKeepingKey][key]
          }
        }
        if (
          this.ifSerial(item[this.dataGoodsInfoKey]) &&
          this.scanFormData[this.dataAmountKey] > 1
        ) {
          return '当前商品已开启序列号管理，数量不能大于1'
        }
        item[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
        this.tableData = [item, ...this.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(item, true)

        this.setTreeExpand()
      } else {
        return res.data.msg || '未查询到该商品'
      }
    },
    //录入模式--无源--将所扫信息通过接口去库存进行查询，根据库存id进行数量累加，没有相同就新增一行
    async modelimportInventory() {
      //如果没有匹配的就新增一条
      if (this.scanFormData[this.dataAmountKey] > this.scanFormData.available) {
        return '库存不足'
      }
      // 灵科: #31130
      this.linkGoods() //转换灵科的结构

      let param = { items: [this.scanFormData], ...this.importInventoryParam }
      const res = await this.$axios.post(this.importInventoryUrl, param)
      if (res.data.code == 200 && res.data.data && res.data.data.length > 0) {
        let item = res.data.data[0]
        for (let i = 0; i < this.tableData.length; i++) {
          let row = this.tableData[i]
          if (this.checkBatchIsEq(row, item)) {
            row[this.dataAmountKey] = calculateUtil.numberAdd(
              this.scanFormData[this.dataAmountKey],
              row[this.dataAmountKey]
            )
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', row, {})
            this.tableData = this.rowToFrist(this.tableData, i)
            // 同步更新 taskData
            this.syncUpdateTaskData(this.tableData[0])

            this.setTreeExpand()
            return
          }
        }
        //没有相同的则直接新增一条数据
        item[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
        // #8365 处理添加到明细的数据
        const allData = this.store?.states?.formData?.items
        const prev = allData[allData.length - 1]
        if (prev?.instrument) item.instrument = prev.instrument

        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
        this.tableData = [item, ...this.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(item, true)

        this.setTreeExpand()
        return
      } else {
        return res.data.msg || '未查询到该商品'
      }
    },
    // 扫码确认
    async onScanConfirm() {
      const isValid = await this.validateRequired()
      if (!isValid.success) {
        this.updateWarnOrErrorMessage(isValid.message, 'error')
        return
      } else {
        this.resetWarnOrErrorMessage()
      }

      let resError = null

      // 校验优联-重复原厂序列号 或者 灵科-重复添加
      resError = this.validRepeatForSerial()

      if (!resError) {
        switch (this.model) {
          case 'checkout': //（有源）根据商品和批号匹配，进行数量累加或者拆行
            resError = this.modelCheckout()
            break
          case 'checkoutAndLocation': //（有源）根据商品和批号及货位进行数量累加
            resError = this.modelCheckoutAndLocation()
            break
          case 'checkoutInputLocation': //（有源）根据商品和批号进行数量累加或者拆行同时可录入货位
            resError = this.modelCheckoutInputLocation()
            break
          case 'passiveCheckoutInputLocation': //（无源）根据商品和批号进行数量累同时可录入货位
            resError = this.modelPassiveCheckoutInputLocation()
            break
          case 'checkOrder': //匹配模式--有源--盘点 根据扫码信息在明细中查询，点击确认时将查询出来的明细添加到上表，数量相同就累加，最后点击保存时提交到后台
            resError = this.modelCheckOrder()
            break
          case 'import': //（有源）根据商品录入批号和数量或拆行，累加数量时需要判断验收结论
            resError = this.modelimport()
            break
          case 'importAndInputLocation': // 录入模式--有源--通过所扫商品与任务明细进行匹配，将扫码其他信息录入到任务明细，累加数量时需要判断货位
            resError = this.modelimportAndInputLocation()
            break
          case 'importAndLocation': //录入模式--有源--通过所扫商品和货位与任务明细进行匹配，将扫码信息查询的库存录入到任务明细
            resError = this.modelimportAndLocation()
            break
          case 'importGoodsAndBatch': //录入模式--无源--跟台商品目录池，将所扫商品及批号信息添加进上表，最后保存直接调后台接口
            resError = this.modelimportGoodsAndBatch()
            break
          case 'importGoodsAndBatchByTrack': //录入模式--无源--来自跟台目录，根据所扫商品与上表进行匹配，相同则数量累加，否则根据接口获取当前明细行，并加入上表
            resError = await this.modelimportGoodsAndBatchByTrack()
            break
          case 'importInventory': //录入模式--无源--将所扫信息通过接口去库存进行查询，根据库存id进行数量累加，没有相同就新增一行
            resError = await this.modelimportInventory()
            break
          default:
            resError = '未配置模式'
            break
        }
      }

      if (resError) {
        this.updateWarnOrErrorMessage(resError, 'error')
        return
      }

      // 状态为编辑，在点击【确认】后需要重置状态为 create
      const ifEdit = this.ifEdit(this.scanFormData)
      if (ifEdit || this.scanStatus === 'update') this.scanStatus = 'create'
      // 可保存
      this.isSave = true
      this.jump({ begin: true })
      // 清空扫码区
      this.resetScanFormData()
      this.resetScanResult()
      this.resetScanTableData?.()
    },
    // 校验重复商品 id + 批号 + 原厂序列号（已开启序列号管理）+ 供应商（灵科）
    validRepeatForSerial() {
      const isLink = this.dataGoodsKeepingKey === 'goodsStore'
      const dataGoodsInfoKey = this.dataGoodsInfoKey
      const dataGoodsKeepingKey = this.dataGoodsKeepingKey
      const tableData = this.tableData
      const scanFormData = this.scanFormData
      const goodsInfo = scanFormData[dataGoodsInfoKey]
      const goodsKeeping = scanFormData[dataGoodsKeepingKey]
      // 是否开启原厂序列号管理
      const keepingSerial = goodsInfo?.keepingSerial
      // 无数据显示文本
      const NO_DATA = '-'
      // 错误提示文本
      let errorMessage = ''
      // 是否重复
      let isRepeat = false

      // Bug#32046，如果是 this.model === 'importGoodsAndBatch' 和处于编辑状态则忽略重复校验
      const ifEdit = this.ifEdit(this.scanFormData)
      if (this.model === 'importGoodsAndBatch' && !ifEdit) {
        for (const cur of tableData) {
          const curInfo = {
            id: cur[dataGoodsInfoKey]?.id,
            [this.dataAmountKey]: cur?.[this.dataAmountKey],
            serialNumber: cur[dataGoodsKeepingKey]?.serialNumber,
            batchNumber: cur[dataGoodsKeepingKey]?.batchNumber,
            targetId: cur[dataGoodsInfoKey]?.target?.id,
          }
          // 商品名添加至错误提示文本中
          errorMessage = goodsInfo?.name ?? NO_DATA
          // 修复Bug#31860，初步重复判断, Bug#31930，先判断是否是编辑状态，看是否解决问题，且未引发其他问题
          isRepeat =
            this.scanStatus !== 'update' &&
            curInfo[this.dataAmountKey] > 0 &&
            goodsInfo?.id === curInfo.id

          // 批号是否有值
          if (curInfo.batchNumber && goodsKeeping?.batchNumber) {
            errorMessage += `，批号：${goodsKeeping?.batchNumber ?? NO_DATA}`
            isRepeat = isRepeat && goodsKeeping?.batchNumber === curInfo.batchNumber
          }
          // 原厂序列号是否已开启
          if (keepingSerial && goodsKeeping?.serialNumber) {
            errorMessage += `，序列号：${goodsKeeping?.serialNumber ?? NO_DATA}`
            isRepeat = isRepeat && goodsKeeping?.serialNumber === curInfo.serialNumber
          }
          // 灵科
          if (isLink) {
            // 供应商是否有值
            if (curInfo.targetId && goodsInfo?.target?.id) {
              errorMessage += `，供应商：${goodsInfo?.target?.name ?? NO_DATA}`
              isRepeat = isRepeat && goodsInfo?.target?.id === curInfo.targetId
            }
          }

          if (isRepeat) break // 发现重复即结束循环
        }
      }

      // 如果重复，则返回警告信息
      if (isRepeat) return `${errorMessage}，重复验收或添加！`

      return null
    },
    setTreeExpand() {
      if (!this.$refs || !this.$refs.crudDataTableTop) return
      this.$nextTick(() => {
        this.$refs.crudDataTableTop.setAllTreeExpand(true)
        this.$refs.crudDataTableTop.setCurrentRow(null, true)
      })
    },
    saveBefore() {
      return new Promise(async (resolve) => {
        if (this.model === 'checkOrder' || this.model === 'importGoodsAndBatch') {
          const res = await this.$axios
            .post(this.saveUrl, { items: this.tableData, ...this.saveParams })
            .catch(() => {
              resolve(new Response({ data: [], code: 404, msg: '接口请求错误' }))
            })
          resolve(res.data)
        } else {
          resolve(new Response({ data: this.tableData }))
        }
      })
    },
  },
}
